import { motion } from "framer-motion";
import {
  defaultBgVariants,
  defaultPanelVariants,
} from "../common/defaultValues";
import PopUpHeader from "../common/PopUpHeader";
import { ReactNode } from "react";

type PopUpContainerProps = {
  children?: ReactNode;
  className?: string;
  title: string;
  onPressBack: () => void;
  onClose: () => void;
} & React.ComponentProps<typeof motion.div>;

const PopUpContainer: React.FC<PopUpContainerProps> = ({
  children,
  className,
  title,
  onPressBack,
  onClose,
  ...divProps
}) => {
  return (
    <>
      <motion.div
        className="fixed inset-0 w-full h-full bg-neutral-500 bg-opacity-40 backdrop-blur-[2px] z-20 flex flex-col flex-grow"
        variants={defaultBgVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.1, ease: "easeOut" }}
        onClick={onClose}
      />
      <motion.div
        className={`fixed max-h-[80vh] bottom-5 left-0 right-0 mx-auto z-30 w-[462px] h-fit px-6 pt-6 pb-8 bg-white rounded-3xl flex flex-col gap-4 ${className}`}
        variants={defaultPanelVariants}
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit="exit"
        transition={{ duration: 0.3, ease: "easeOut" }}
        {...divProps}
      >
        {/* Header */}
        <PopUpHeader title={title} handlePressBack={onPressBack} />
        {children}
      </motion.div>
    </>
  );
};

export default PopUpContainer;
